import { required } from 'react-admin';
import { validReferralId } from '../../user/validators';

export const validateCreateBusiness = {
  name: [required()],
  referralId: [validReferralId],
};
